module.exports = __webpack_public_path__ + "static/media/sk.a5af0a28.svg";